<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-file-chart-outline</v-icon
            >
            <pre><v-toolbar-title><h2>Listado IVA — Facturas entrantes</h2></v-toolbar-title></pre>
        </v-toolbar>

        <v-row class="mt-3">
            <v-col cols="12" md="3">
                <v-select
                    v-model="anio"
                    :items="anios"
                    label="Año"
                    outlined
                    dense
                    hide-details
                ></v-select>
            </v-col>
            <v-col cols="12" md="3">
                <v-select
                    v-model="trimestre"
                    :items="trimestres"
                    item-text="text"
                    item-value="value"
                    label="Trimestre"
                    outlined
                    dense
                    hide-details
                ></v-select>
            </v-col>
            <v-col cols="12" md="6">
                <FilterComponentVue
                    :headers="filter_headers"
                    v-model="filtros"
                ></FilterComponentVue>
            </v-col>
        </v-row>

        <v-row class="mb-2">
            <v-col cols="12">
                <v-btn color="blue darken-1" dark class="mr-2" @click="abrirPdf">
                    <v-icon left small>mdi-file-pdf-box</v-icon>
                    Ver / imprimir PDF
                </v-btn>
                <span class="caption grey--text">
                    Filtra por fecha de emisión de la factura (igual que en otras listas).
                    El trimestre rellena automáticamente el rango de fechas.
                </span>
            </v-col>
        </v-row>

        <v-row class="mb-3">
            <v-col cols="12" md="4">
                <v-card outlined class="pa-2">
                    <div class="caption grey--text">Total bases</div>
                    <div class="title">{{ formatPrice(totales.base) }} €</div>
                </v-card>
            </v-col>
            <v-col cols="12" md="4">
                <v-card outlined class="pa-2">
                    <div class="caption grey--text">Total cuota IVA</div>
                    <div class="title">{{ formatPrice(totales.cuota_iva) }} €</div>
                </v-card>
            </v-col>
            <v-col cols="12" md="4">
                <v-card outlined class="pa-2">
                    <div class="caption grey--text">Total (bases + IVA − retención)</div>
                    <div class="title">{{ formatPrice(totales.total) }} €</div>
                </v-card>
            </v-col>
        </v-row>

        <v-data-table
            dense
            :headers="headers"
            :items="rows"
            :custom-sort="ordenarFilas"
            :sort-by="['nro_registro']"
            :sort-desc="[false]"
            :items-per-page="25"
            item-key="id_linea"
            class="elevation-1"
            :loading="cargando"
            loading-text="Cargando..."
        >
            <template v-slot:item.base="{ item }">
                {{ formatPrice(item.base) }}
            </template>
            <template v-slot:item.cuota_iva="{ item }">
                {{ formatPrice(item.cuota_iva) }}
            </template>
            <template v-slot:item.retencion="{ item }">
                {{ formatPrice(item.retencion) }}
            </template>
            <template v-slot:item.total_linea="{ item }">
                {{ formatPrice(item.total_linea) }}
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { debounce } from "../../../helpers";
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
import { formatPrice } from "../../../helpers";

export default {
    name: "ListadoIvaEntrantes",
    components: { FilterComponentVue },
    data() {
        const y = new Date().getFullYear();
        return {
            cargando: false,
            empresa: "",
            rows: [],
            totales: { base: 0, cuota_iva: 0, retencion: 0, total: 0 },
            periodo: { desde: "", hasta: "" },
            anio: y,
            anios: [y, y - 1, y - 2, y - 3],
            trimestre: Math.floor(new Date().getMonth() / 3) + 1,
            trimestres: [
                { text: "1 — Ene / Mar", value: 1 },
                { text: "2 — Abr / Jun", value: 2 },
                { text: "3 — Jul / Sep", value: 3 },
                { text: "4 — Oct / Dic", value: 4 },
            ],
            filtros: {},
            filter_headers: [
                {
                    title: "Fecha de emisión",
                    type: "date",
                    active: true,
                    model: "fecha",
                },
            ],
            headers: [
                { text: "Nº registro", value: "nro_registro" },
                { text: "F. registro", value: "fecha_registro", sortable: false },
                { text: "Fecha fact.", value: "fecha_factura", sortable: false },
                {
                    text: "Nº fact. proveedor",
                    value: "nro_factura_proveedor",
                    sortable: false,
                },
                { text: "Proveedor", value: "proveedor", sortable: false },
                { text: "CIF/NIF", value: "cif", sortable: false },
                { text: "Base", value: "base", sortable: false, align: "end" },
                { text: "% IVA", value: "iva_pct", sortable: false, align: "end" },
                {
                    text: "Cuota IVA",
                    value: "cuota_iva",
                    sortable: false,
                    align: "end",
                },
                {
                    text: "Retención",
                    value: "retencion",
                    sortable: false,
                    align: "end",
                },
                {
                    text: "Total línea",
                    value: "total_linea",
                    sortable: false,
                    align: "end",
                },
            ],
        };
    },
    created() {
        this.aplicarTrimestreAFechas();
        this.cargarDatos();
    },
    watch: {
        anio() {
            this.aplicarTrimestreAFechas();
        },
        trimestre() {
            this.aplicarTrimestreAFechas();
        },
        filtros: {
            deep: true,
            handler: debounce(function () {
                this.cargarDatos();
            }, 400),
        },
    },
    methods: {
        formatPrice,
        ordenarFilas(items, sortBy, sortDesc) {
            const campos = Array.isArray(sortBy)
                ? sortBy
                : sortBy
                ? [sortBy]
                : [];
            const descensos = Array.isArray(sortDesc) ? sortDesc : [sortDesc];
            if (!campos.length || campos[0] !== "nro_registro") {
                return items;
            }
            const desc = !!descensos[0];
            return items.slice().sort((a, b) => {
                const cmp = this.compararNroRegistro(
                    a.nro_registro,
                    b.nro_registro
                );
                return desc ? -cmp : cmp;
            });
        },
        compararNroRegistro(a, b) {
            const partes = (valor) => {
                const texto = String(valor || "");
                const [anio, numero] = texto.split("/");
                return {
                    anio: parseInt(anio, 10) || 0,
                    numero: parseInt(numero, 10) || 0,
                    texto,
                };
            };
            const pa = partes(a);
            const pb = partes(b);
            if (pa.anio !== pb.anio) return pa.anio - pb.anio;
            if (pa.numero !== pb.numero) return pa.numero - pb.numero;
            return pa.texto.localeCompare(pb.texto);
        },
        aplicarTrimestreAFechas() {
            const y = this.anio;
            const t = this.trimestre;
            const starts = [
                `${y}-01-01`,
                `${y}-04-01`,
                `${y}-07-01`,
                `${y}-10-01`,
            ];
            const ends = [
                `${y}-03-31`,
                `${y}-06-30`,
                `${y}-09-30`,
                `${y}-12-31`,
            ];
            this.$set(this.filtros, "fecha", {
                start: starts[t - 1],
                end: ends[t - 1],
            });
        },
        cargarDatos() {
            const desde = this.filtros.fecha?.start;
            const hasta = this.filtros.fecha?.end;
            if (!desde || !hasta) {
                return;
            }
            this.cargando = true;
            axios
                .get("api/listado-iva-facturas-entrantes", {
                    params: {
                        fecha_desde: desde,
                        fecha_hasta: hasta,
                    },
                })
                .then((res) => {
                    if (res.data.code === 200) {
                        this.rows = res.data.rows || [];
                        this.totales = res.data.totales || {
                            base: 0,
                            cuota_iva: 0,
                            retencion: 0,
                            total: 0,
                        };
                        this.periodo = res.data.periodo || {};
                        this.empresa = res.data.empresa || "";
                    }
                })
                .catch((err) => {
                    const msg =
                        err.response?.data?.message ||
                        err.response?.data?.error ||
                        "Error cargando el listado";
                    this.$custom_error(msg);
                })
                .finally(() => {
                    this.cargando = false;
                });
        },
        async abrirPdf() {
            const desde = this.filtros.fecha?.start;
            const hasta = this.filtros.fecha?.end;
            if (!desde || !hasta) {
                this.$custom_error("Seleccione un rango de fechas");
                return;
            }
            this.$store.dispatch("isLoading", true);
            try {
                const res = await axios.get(
                    "api/pdf-listado-iva-facturas-entrantes",
                    {
                        params: {
                            fecha_desde: desde,
                            fecha_hasta: hasta,
                        },
                        responseType: "blob",
                    }
                );
                const url = window.URL.createObjectURL(
                    new Blob([res.data], { type: "application/pdf" })
                );
                window.open(url, "_blank");
                setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
            } catch (err) {
                let msg = "No se pudo generar el PDF";
                if (err.response?.data instanceof Blob) {
                    try {
                        const t = await err.response.data.text();
                        const j = JSON.parse(t);
                        if (j.message) msg = j.message;
                    } catch (e) {
                        /* mensaje por defecto */
                    }
                }
                this.$custom_error(msg);
            } finally {
                this.$store.dispatch("isLoading", false);
            }
        },
    },
};
</script>
